<template>
  <div id="app">

    <div class="youku" v-show="logo"></div>

    <div class="rule" @click="showRule"></div>

    <div class="input">
      <div class="phone">
        <img src="https://cbshowhot.cdn.changbaimg.com/!/yunying/exchange/phone.png" alt="">
        <input type="text" v-model="phone" placeholder="请输入已绑定唱吧账号的手机号码">
      </div>

      <div class="coupon phone">
        <img src="https://cbshowhot.cdn.changbaimg.com/!/yunying/exchange/coupon.png" alt="">
        <input type="text" v-model="coupon" placeholder="请输入兑换码，兑换会员/礼物/优惠券">
      </div>
    </div>

    <button class="makeSure" @click="exchange">确认兑换</button>

    <!-- 规则弹窗 -->

    <div class="rule-window" v-show="ruleWindow">
      <div class="content">
        <div class="moji">
          <p><strong>兑换说明</strong></p>
          <ul>
            <li>1. 每个手机号/唱吧账号每个自然月仅可兑换3次会员，超出次数无法兑换。次月可再次兑换。如有问题，可联系公众号线上客服。</li></br>
            <li>2. 无论兑换何种奖品，请务必确认您填写的手机号码已成功绑定唱吧账号。</li></br>
            <li>3. 兑换成功后，奖品将直接发送到您的唱吧账户中，请到唱吧app确认。</li></br>
            <li>4. 兑换奖品的有效期从兑换成功后开始计算。</li></br>
            <li>5. 如有任何问题请联系唱吧公众号客服</li></br>
          </ul>
          <h3>* 最终解释权归唱吧所有 *</h3>
        </div>

        <div class="close" @click="close"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      logo: false,
      ruleWindow: false,
      phone: "",
      coupon: ""
    };
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const url = document.location.toString();
      const para = url.split("?")[1];
      const arrUrl = para.split("&");

      if (arrUrl.length > 0) {
        for (let i = 0; i < arrUrl.length; i++) {
          if (arrUrl[i].split("=")[0] == 'youku') {
            this.logo = true;
          }
        }
      }
    },

    showRule() {
      this.ruleWindow = true;
    },

    close() {
      this.ruleWindow = false;
    },

    async exchange() {
      if (!this.phone) {
        alert("电话号码不能为空");
        return false;
      }
      else if (!this.coupon) {
        alert("兑换码不能为空");
        return false;
      }
      const refsrc = this.$commonObj.utils.getQueryStrFn('refsrc') || '';
      let _sourceType = ''

      refsrc === 'hyzx' ? _sourceType = 2 : _sourceType = 3

      const { code, msg } = await this.$fetch(
        "/api/master/exchangeCenterNew/exchange",
        {
          data: {
            phone: this.phone,
            exchangeCode: this.coupon,
            source: _sourceType
          }
        }
      )

      if (code == 1) {
        alert("兑换成功");
        this.init();
        this.phone = "";
        this.coupon = "";
      }
      else {
        alert(msg);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.youku {
  background: url("https://cbshowhot.cdn.changbaimg.com/!/yunying/exchange/logo.png") no-repeat;
  background-size: 100%;
  width: 108px;
  height: 40px;
  position: absolute;
  margin-top: 8px;
  left: 26px;
}

.rule {
  background: url("https://cbshowhot.cdn.changbaimg.com/!/yunying/exchange/rule.png") no-repeat;
  background-size: 100%;
  width: 156px;
  height: 52px;
  margin-top: 24px;
  margin-left: 570px;
}

.input {
  height: 264px;
  width: 616px;
  margin: 627px auto 0;

  .phone {
    img {
      width: 36px;
      height: 57.6px;
      top: 50%;
      transform: translateY(28%);
    }

    input {
      width: 544px;
      height: 88px;
      background: #ffffff;
      border-radius: 16px;
      margin-left: 28px;
      font-size: 28px;
      color: #121212;
      line-height: 32px;
      padding-left: 20px;
    }

    input::placeholder {
      color: #ccc;
    }
  }

  .coupon {
    width: 616px;
    margin-top: 40px;
    margin-left: -10px;

    img {
      width: 50.4px;
      height: 36px;
      top: 50%;
      transform: translateY(10%);
    }

    input {
      margin-left: 20px;
    }
  }

}

.makeSure {
  position: absolute;
  background-color: #ffcc24;
  box-shadow: inset 0 2px 7px 0 rgba(255, 214, 7, 0.60);
  border-radius: 60px;
  width: 438px;
  height: 88px;
  margin-top: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 36px;
  color: #952119;
  text-align: center;
  line-height: 32px;
  border: none;
}

.rule-window {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  margin-left: 0;
  width: 750px;
  height: 100%;

  .content {
    width: 580px;
    height: 760px;
    position: absolute;
    top: 180px;
    left: 86px;
    background: #fff;
    border-radius: 16px;
    font-size: 28px;
    color: #aaaaaa;
    letter-spacing: 0;
    padding-top: 60px;

    .moji {
      width: 486px;
      margin: 0 auto;

      p {
        margin: 0 auto;
        width: 150px;
        margin-bottom: 40px;
        font-size: 36px;
        color: #121212;
      }

      h3 {
        font-size: 20px;
        color: #ee675d;
        letter-spacing: 0;
        // width: 226px;
        margin-top: 42px;
        margin-left: 126px;
      }
    }
  }

  .close {
    background: url("https://cbshowhot.cdn.changbaimg.com/!/changba/close/close.png");
    background-size: 100%;
    width: 80px;
    height: 80px;
    margin-top: 100px;
    margin-left: 260px;
  }
}
</style>
